import { render, staticRenderFns } from "./DetailResumen.vue?vue&type=template&id=91d0c4e6&"
import script from "./DetailResumen.vue?vue&type=script&lang=ts&"
export * from "./DetailResumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports